import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { isDirty } from 'redux-form';

import {
  onClickApplySetItem,
  onClickRow,
  modifiersRequest,
} from 'actions/businessLibrary/modifier';
import { askConfirmAction } from 'actions/confirm-action';

import styles from './List.css';

class List extends React.Component {
  render() {
    const { modifiers, modifierDetail } = this.props;

    return (
      <div className={styles.wrapper}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th className={styles.name}>Modifier Set Name</th>
              <th className={styles.option}>Options</th>
              <th className={styles.apply} />
            </tr>
          </thead>
        </table>
        <div
          className={`${
            styles['table-content-wrapper']
          } modifiers-table-content-wrapper`}
        >
          <InfiniteScroll
            pageStart={1}
            loadMore={this.onReachBottom}
            hasMore={this.hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table className={`${styles['table-content']}`}>
              <tbody>
                {modifiers.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center' }}>
                      No data to display
                    </td>
                  </tr>
                )}
                {modifiers.length > 0 &&
                  modifiers.map(modifier => {
                    return (
                      <tr
                        key={modifier.id}
                        className={`${
                          modifierDetail && modifier.id === modifierDetail.id
                            ? styles.selected
                            : ''
                        }`}
                        onClick={() => this.onClickRow(modifier)}
                      >
                        <td className={styles.name}>{modifier.name}</td>
                        <td className={styles.option}>
                          {this.renderOptionCell(modifier)}
                        </td>
                        <td className={styles.apply}>
                          <a
                            className="btn btn-default btn-sm"
                            type="button"
                            onClick={e => this.onClickApplySetItem(e, modifier)}
                          >
                            Apply Set Item
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    );
  }

  onClickRow = modifier => {
    const { isDirtyModifier } = this.props;
    if (isDirtyModifier) {
      this.props.dispatch(askConfirmAction(onClickRow(modifier)));
    } else {
      this.props.dispatch(onClickRow(modifier));
    }
  };

  onClickApplySetItem = (e, modifier) => {
    const { dispatch } = this.props;
    e.stopPropagation();
    e.preventDefault();
    dispatch(onClickApplySetItem(modifier));
  };

  onReachBottom = () => {
    const {
      dispatch,
      modifierMeta: { currentPage, total_page },
      modifiers,
    } = this.props;
    if (currentPage < total_page) {
      dispatch(modifiersRequest({ page: currentPage + 1 }, modifiers));
    }
  };

  hasMore = () => {
    const { modifierMeta } = this.props;
    return modifierMeta.currentPage < modifierMeta.total_page;
  };

  renderOptionCell = modifier => {
    return modifier.modifier_options.map((opt, idx) => {
      if (idx > 0) {
        return `, ${opt.name}`;
      }
      return opt.name;
    });
  };
}

function mapStateToProps(state) {
  const {
    modifiers,
    modifierMeta,
    modifierDetail,
  } = state.businessLibrary.modifierHub;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    modifiers,
    modifierDetail,
    modifierMeta,
    showLoadingSpinnerPage,
    isDirtyModifier: isDirty('modifierHub')(state),
    businessId: state.moka.user.business.id,
  };
}

export default connect(mapStateToProps)(List);
